import request from '@/utils/request';

const SESSION_POLICY_KEY = 'ec_policy_agreed';

let sessionPolicyAgreed = false;

export const POLICY_GATE_PATH = '/policy';
export const POLICY_EXEMPT_PATHS = [POLICY_GATE_PATH, '/logout'];

function getPolicyUserKey() {
  return localStorage.getItem('ec_current_usid') || '';
}

export function markSessionPolicyAgreed() {
  sessionPolicyAgreed = true;
  try {
    sessionStorage.setItem(SESSION_POLICY_KEY, getPolicyUserKey());
  } catch {
    // Ignore quota / private-mode write failures.
  }
}

export function clearSessionPolicyAgreed() {
  sessionPolicyAgreed = false;
  try {
    sessionStorage.removeItem(SESSION_POLICY_KEY);
  } catch {
    // Ignore storage access failures.
  }
}

export function isSessionPolicyAgreed() {
  if (sessionPolicyAgreed) {
    return true;
  }

  try {
    const stored = sessionStorage.getItem(SESSION_POLICY_KEY);
    if (stored !== null && stored === getPolicyUserKey()) {
      sessionPolicyAgreed = true;
      return true;
    }
  } catch {
    // Ignore storage access failures.
  }

  return false;
}

export function isOverridden(status) {
  if (!status) {
    return false;
  }
  return status.isOverriden === true || status.isOverriden === 'true';
}

function isAgreedFlag(value) {
  return value === true || value === 'true';
}

export function needsPolicyAgreement(status) {
  if (!status || isOverridden(status)) {
    return false;
  }
  return (
    !isAgreedFlag(status.policyAgree) ||
    !isAgreedFlag(status.productPolicyAgree) ||
    !isAgreedFlag(status.investmentSchemeAdvisoryAgree)
  );
}

export function isPolicyFullyAgreed(status) {
  return Boolean(status) && !needsPolicyAgreement(status);
}

export function getPlanHomePath(pt) {
  switch (pt) {
    case 'bibo':
      return '/dashboardbibo';
    case 'ecc':
      return '/dashboardecc';
    case 'pcp':
      return '/dashboardpcp';
    case 'ovi':
    case 'ecp':
    case 'edp':
    case 'iglow':
    default:
      return '/estore';
  }
}

export function resolvePostPolicyRedirect(redirectQuery, pt) {
  if (
    redirectQuery &&
    typeof redirectQuery === 'string' &&
    redirectQuery.startsWith('/') &&
    !redirectQuery.startsWith('//') &&
    redirectQuery !== POLICY_GATE_PATH
  ) {
    return redirectQuery;
  }
  return getPlanHomePath(pt);
}

export function isPolicyExemptPath(path) {
  return POLICY_EXEMPT_PATHS.some((exemptPath) => path === exemptPath || path.startsWith(`${exemptPath}?`));
}

export async function fetchPolicyAgreementStatus() {
  const response = await request({ url: 'vgetPolicyAgreementStatus', method: 'get' });
  return (response && response.data) || null;
}
